module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Logo-weiss.b216cfe7.svg";